export const idf = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 26,
  inputPaddingInline: 25,

  inputHeight: 50,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 16,
  inputFontFamily: '"Montserrat", sans-serif',
  inputColor: "#A9A9A9",
  inputBackgroundColor: "#ffffff",
  inputFontWeight: 400,

  inputBorderColor: "#A9A9A9",
  inputBorderWidth: 1,
  inputBorderRadius: 4,

  inputHoverColor: "#A9A9A9",
  inputHoverBorderColor: "#A9A9A9",
  inputHoverBackgroundColor: "#ffffff",

  // **********************************
  //  Select field
  selectTopSpacing: 26,
  selectPaddingInline: 25,

  selectHeight: 50,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 16,
  selectFontFamily: '"Montserrat", sans-serif',
  selectColor: "#A9A9A9",
  selectBackgroundColor: "#F0F0F0",
  selectFontWeight: 400,

  selectBorderColor: "transparent",
  selectBorderWidth: 1,
  selectBorderRadius: 4,

  selectHoverColor: "transparent",
  selectHoverBorderColor: "#A9A9A9",
  selectHoverBackgroundColor: "#F0F0F0",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 26,
  textAreaPaddingInline: 25,

  textAreaHeight: 50,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 16,
  textAreaFontFamily: '"Montserrat", sans-serif',
  textAreaColor: "#A9A9A9",
  textAreaBackgroundColor: "#ffffff",
  textAreaFontWeight: 400,

  textAreaBorderColor: "#A9A9A9",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 4,

  textAreaHoverColor: "#A9A9A9",
  textAreaHoverBorderColor: "#A9A9A9",
  textAreaHoverBackgroundColor: "#ffffff",

  // **********************************
  //  placeholder
  placeholderColor: "#A9A9A9",
  placeholderFontFamily: '"Montserrat", sans-serif',
  placeholderFontSize: 16,
  placeholderFontWeight: 400,
  placeholderHoverColor: "#A9A9A9",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 12,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 14,
  fieldLabelColor: "#0067B1",
  fieldLabelFontWeight: 500,
  fieldLabelColorAsterisk: "#0067B1",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Montserrat", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#A9A9A9",
  descriptionFontSize: 14,
  descriptionFontWeight: 400,
  descriptionFontFamily: '"Montserrat", sans-serif',
  descriptionTopSpacing: 10,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 20,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 2,
  checkboxUncheckedBorderColor: "#EBEBEB",
  checkboxUncheckedBackgroundColor: "#ffffff",
  checkboxCheckedBackgroundColor: "#0067B1",
  checkboxCheckedBorderColor: "#EBEBEB",
  checkboxCheckedColor: "#ffffff",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Montserrat", sans-serif',
  checkboxLabelFontSize: 14,
  checkboxLabelFontWeight: 400,
  checkboxLabelColor: "#6D6E71",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 20,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#EBEBEB",
  radioUncheckedBackgroundColor: "#ffffff",
  radioCheckedBackgroundColor: "#0067B1",
  radioCheckedBorderColor: "#EBEBEB",

  radioAlignment: "none",

  radioLabelFontFamily: '"Montserrat", sans-serif',
  radioLabelFontSize: 14,
  radioLabelFontWeight: 400,
  radioLabelColor: "#6D6E71",

  // **********************************
  // submit button

  submitMarginTop: 35,
  submitFontSize: 16,
  submitFontFamily: "'Montserrat', sans-serif",
  submitWidth: 135,
  submitWidthUnits: "px",
  submitHeight: 50,
  submitBorderRadius: 4,
  submitBorderWidth: 1,
  submitBackground: "#0067B1",
  submitColor: "#ffffff",
  submitBorderColor: "#0067B1",
  submitBackgroundHover: "#0067B1",
  submitBorderColorHover: "#0067B1",
  submitColorHover: "#ffffff",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 400,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "center",
};

  